import {configureStore} from "@reduxjs/toolkit"
import DispatchReducer from "./reducers/Dispatch"

export default configureStore({
  reducer:{
    DispatchReducer,
  }
})